/**
 * Estado de onboarding por tenant, en localStorage (la zona horaria sí se
 * persiste en el backend; estos flags solo controlan que la bienvenida y el
 * recorrido no se repitan). El recorrido es re-lanzable manualmente.
 */
function key(prefix: string, tenantId: string | null): string {
  return `${prefix}:${tenantId ?? 'anon'}`;
}

export function isOnboarded(tenantId: string | null): boolean {
  try {
    return window.localStorage.getItem(key('cajita-onboarded', tenantId)) === '1';
  } catch {
    return false;
  }
}

export function markOnboarded(tenantId: string | null): void {
  try {
    window.localStorage.setItem(key('cajita-onboarded', tenantId), '1');
  } catch {
    /* ignore */
  }
}

export function isTourDone(tenantId: string | null): boolean {
  try {
    return window.localStorage.getItem(key('cajita-tour-done', tenantId)) === '1';
  } catch {
    return false;
  }
}

export function markTourDone(tenantId: string | null): void {
  try {
    window.localStorage.setItem(key('cajita-tour-done', tenantId), '1');
  } catch {
    /* ignore */
  }
}
